/* global allProductData */
import Vue from 'vue';
import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';
import trimStart from 'lodash/trimStart';
import startsWith from 'lodash/startsWith';
import { toggleAttribute } from './helpers';

import Paginate from './paginate/index';

// Add the pagination component
Vue.component('paginate', Paginate, {
	// pass totalPages as a prop from the main Vue instance
	props: ['totalPages']
});

let productCollection = {};
let totalPages;
let allResults;

new Vue({
	el: '.all-products-search',
	data: {
		isLoading: true,
		hasFiltered: false,
		filtersPanelExpanded: false,
		products: [],
		storedQueryString: '',
		gridLayout: true,
		categories: allProductData['product-category'],
		brands: allProductData['product-brand'],
		ingredients: allProductData['product-main-ingredient'],
		dietaryAlts: allProductData['product-dietary-alternative'],
		filteredCats: {
			name: 'product-category',
			items: []
		},
		filteredBrands: {
			name: 'product-brand',
			items: []
		},
		filteredIngredients: {
			name: 'product-main-ingredient',
			items: []
		},
		filteredDietaryAlts: {
			name: 'product-dietary-alternative',
			items: []
		},
		order: 'asc',
		page: 1,
		totalPages: 1,
		resultsCount: 0,
		resultsFrom: 1,
		resultsTo: 0,
		query: {
			data: {
				per_page: 15,
				order: 'asc',
				orderby: 'title',
				lang: allProductData['lang'],
				post_parent: 0,
				_fields:
					'title,product_title,product-brand,product-dietary-alternative,description,link,featured_image'
			}
		}
	},
	created() {
		window.onpopstate = this.doPopState;
		this.newGetQueryParams();
	},
	mounted() {
		this.doApiCall();
		this.hasDoneFiltering();
	},
	computed: {
		filteredProducts() {
			return this.products;
		}
	},

	methods: {
		doApiCall() {
			wp.api.loadPromise
				.done(function() {
					// Initialize Product Collection
					productCollection = new wp.api.collections.Product();
				})
				.then(() => {
					this.apiQuery();
				});
		},
		hasDoneFiltering() {
			// if any of the filtered data objects have items
			// then we've done some filtering, so set
			// hasFiltered to true
			if (
				this.filteredBrands.items.length ||
				this.filteredCats.items.length ||
				this.filteredIngredients.items.length ||
				this.filteredDietaryAlts.items.length
			) {
				this.hasFiltered = true;
			} else {
				this.hasFiltered = false;
			}
		},
		listenForKeyboardFiltering(e) {
			// toggle this input being checked or not
			e.target.closest('.product-sidebar-filters__filter-item').querySelector('input').click();
		},
		// listen for return keypress on sidebar filters
		newGetQueryParams() {
			const parsedURL = queryString.parse(location.search);
			// Get the keys and values from the parsed object.
			// updated them in Vue's data
			for (let key in parsedURL) {
				let value = parsedURL[key];
				if (startsWith(key, 'filter-')) {
					key = trimStart(key, 'filter-');
				}
				value = value.split(',');
				this.vueifyQueryParams(key, value);
			}
		},
		/**
		 * Takes a key / value pair and adds it to
		 * its associated Vue data property
		 *
		 * example: product-brands 3064,3072
		 * adds those two ids to filteredBrands
		 */
		vueifyQueryParams(key, value) {
			switch (key) {
				case 'product-category':
					value.forEach(id => this.filteredCats.items.push(parseInt(id, 10)));
					break;
				case 'product-brand':
					value.forEach(id => this.filteredBrands.items.push(parseInt(id, 10)));
					break;
				case 'product-main-ingredient':
					value.forEach(id =>
						this.filteredIngredients.items.push(parseInt(id, 10))
					);
					break;
				case 'product-dietary-alternative':
					value.forEach(id =>
						this.filteredDietaryAlts.items.push(parseInt(id, 10))
					);
					break;
				case 'order':
					this.order = value.toString();
					break;
				case 'page':
					this.page = parseInt(value, 10);
					break;
			}
		},
		apiQuery() {
			this.isLoading = true;
			this.setQueryData();
			productCollection.fetch(this.query).done(this.parseData);
		},
		setQueryData() {
			// get all filterable lists from Vue's data object
			const filterableLists = [
				this.filteredCats,
				this.filteredBrands,
				this.filteredIngredients,
				this.filteredDietaryAlts
			];
			// remove all tax querys and add according to the set filtered data.
			filterableLists.forEach(filterableList => {
				delete this.query.data[filterableList.name];
				if (filterableList.items.length) {
					this.query.data[filterableList.name] = filterableList.items;
				}
			});
			this.query.data.page = this.page;
			this.query.data.order = this.order;
		},
		parseData(response) {
			this.products = response;
			this.totalPages = productCollection.state.totalPages;
			this.resultsCount = productCollection.state.totalObjects;
			this.resultsFrom = productCollection.state.currentPage;
			if (productCollection.state.currentPage > 1) {
				this.resultsFrom = (productCollection.state.currentPage - 1) * 15 + 1;
			}
			this.resultsTo = this.resultsFrom - 1 + productCollection.length;
			this.isLoading = false;
		},
		setQueryStringParams() {
			// get all filterable lists from Vue's data object
			const filterableLists = [
				this.filteredCats,
				this.filteredBrands,
				this.filteredIngredients,
				this.filteredDietaryAlts
			];

			// Reset storedQueryString to and re-add filtered items each time we run this function
			this.storedQueryString = '';

			let tempQueryString = '';

			// FirstRun gets a ?, subsequent runs get an &
			let join = '?';

			// loop over each filterable list and add any items in its array
			filterableLists.forEach(filterableList => {
				if (filterableList.items.length) {
					tempQueryString =
						join +
						'filter-' +
						filterableList.name +
						'=' +
						filterableList.items.toString();
					join = '&';
					this.storedQueryString += tempQueryString;
				}
				// Concat storedQueryString as we loop over the filterable lists
			});

			// Set Order and Pagination
			this.storedQueryString += join + 'filter-order=' + this.order;
			this.storedQueryString += '&filter-page=' + this.page;

			this.apiQuery();

			// Scroll back to top when you filter
			document.documentElement.scrollTop = 0;

			if (!isEmpty(this.storedQueryString)) {
				history.pushState({}, false, this.storedQueryString);
			} else {
				let pageUrl = window.location.href.split('?');
				history.pushState({}, false, pageUrl[0]);
			}

			this.hasDoneFiltering();
		},
		toggleChildrenFiltersOpen(e) {
			const targetFilter = e.target.parentNode.querySelector(
				'.product-sidebar-filters'
			);

			toggleAttribute(targetFilter, 'aria-hidden');
			toggleAttribute( e.target, 'aria-expanded' );
		},
		doPopState() {
			this.resetSearch(false);
			this.newGetQueryParams();
			this.apiQuery();
		},
		resetSearch(clearQueryString = true) {
			// empty all filterable lists
			this.filteredCats.items = [];
			this.filteredBrands.items = [];
			this.filteredIngredients.items = [];
			this.filteredDietaryAlts.items = [];
			this.order = 'asc';
			this.page = 1;
			// reset pagination to 1
			this.$refs.paginate.selected = 0;
			if (clearQueryString) {
				this.setQueryStringParams();
			}
		},
		toggleLayout(event) {
			if (
				event.target.closest('button').classList.contains('current-layout-option')
			) {
				return;
			}

			this.gridLayout = !this.gridLayout;
		},
		toggleFiltersPanelOpen() {
			this.filtersPanelExpanded = !this.filtersPanelExpanded;
		},
		paginationHandler(page) {
			this.page = page;
			this.setQueryStringParams();
		}
	},
	filters: {
		capitalize(value) {
			if (!value) {
				return '';
			}
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	}
});
